"use strict";
module.exports = Object.freeze({
    OR: 'or',
    AND: 'and',
    EQUALS: 'equals',
    ARRAY_CONTAINS: 'array-contains',
    ARRAY_NOT_CONTAINS: 'array-not-contains',
    NOT_EQUALS: 'not-equals',
    CONTAINS: 'contains',
    NOT_CONTAINS: 'not-contains',
    STARTS_WITH: 'starts-with',
    NOT_STARTS_WITH: 'not-starts-with',
    ENDS_WITH: 'ends-with',
    NOT_ENDS_WITH: 'not-ends-with',
    GREATER_THAN: 'greater-than',
    LESS_THAN: 'less-than',
    AFTER: 'is-after',
    BEFORE: 'is-before',
    BETWEEN: 'between',
    IN_THE_NEXT: 'in-the-next',
    HAS_PASSED: 'has-passed',
});
//# sourceMappingURL=operators.js.map